const VBTournamentsPrograms = [
    {
        id: 1,
        title: "ADS Snow Globe Classic",
        status: "Upcoming",
        description:
            "Registration Deadline is Dec 5.",
        startDate: "2026-12-19",
        endDate: "2026-12-19",
        date: "Dec 19",
        ageGroup: "10U - 12U & 17U - 18U",
        price: "$230",
        location:
            "ADS Sports Complex, 10251 E Loop 1604 N, Converse, TX 78109",

        locationUrl:
            "https://maps.google.com/?q=10251+E+Loop+1604+N+Converse+TX+78109",

        registrationUrl: "https://www.advancedeventsystems.com/46335"
    },
    {
        id: 2,
        title: "ADS New Year Showdown",
        status: "upcoming",
        description: "Registration Deadline is Dec 19",
        startDate: "2027-01-02",
        endDate: "2027-01-02",
        date: "Jan 2",
        ageGroup: "10U - 12U",
        price: "$230",
        location:
            "ADS Sports Complex, 10251 E Loop 1604 N, Converse, TX 78109",
        locationUrl:
            "https://maps.google.com/?q=10251+E+Loop+1604+N+Converse+TX+78109",

        registrationUrl: "https://www.advancedeventsystems.com/46337"
    },
    {
        id: 3,
        title: "ADS Battle of the Dome #1",
        status: "upcoming",
        description: "Registration Deadline is Jan 2",
        startDate: "2027-01-16",
        endDate: "2027-01-16",
        date: "Jan 16",
        ageGroup: "16U - 17U",
        price: "$230",
        location:
            "ADS Sports Complex, 10251 E Loop 1604 N, Converse, TX 78109",
        locationUrl:
            "https://maps.google.com/?q=10251+E+Loop+1604+N+Converse+TX+78109",

        registrationUrl: "https://www.advancedeventsystems.com/46340"
    },
    {
        id: 4,
        title: "ADS VB Developmental League #1",
        status: "upcoming",
        description: "Registration Deadline is Jan 3",
        startDate: "2027-01-17",
        endDate: "2027-01-17",
        date: "Jan 17",
        ageGroup: "9U - 12U",
        price: "$145",
        location:
            "ADS Sports Complex, 10251 E Loop 1604 N, Converse, TX 78109",
        locationUrl:
            "https://maps.google.com/?q=10251+E+Loop+1604+N+Converse+TX+78109",

        registrationUrl: "https://www.advancedeventsystems.com/46345"
    },
    {
        id: 5,
        title: "ADS Battle of the Dome #2",
        status: "upcoming",
        description: "Registration Deadline is Jan 16",
        startDate: "2027-01-30",
        endDate: "2027-01-30",
        date: "Jan 17",
        ageGroup: "11U - 13U",
        price: "$230",
        location:
            "ADS Sports Complex, 10251 E Loop 1604 N, Converse, TX 78109",
        locationUrl:
            "https://maps.google.com/?q=10251+E+Loop+1604+N+Converse+TX+78109",

        registrationUrl: "https://www.advancedeventsystems.com/46611"
    },
    {
        id: 6,
        title: "ADS VB Developmental League #2 - Girls & Boys",
        status: "upcoming",
        description: "Registration Deadline is Jan 17",
        startDate: "2027-01-31",
        endDate: "2027-01-31",
        date: "Jan 31",
        ageGroup: "9U - 12U",
        price: "$145",
        location:
            "ADS Sports Complex, 10251 E Loop 1604 N, Converse, TX 78109",
        locationUrl:
            "https://maps.google.com/?q=10251+E+Loop+1604+N+Converse+TX+78109",

        registrationUrl: "https://www.advancedeventsystems.com/46612"
    },
    {
        id: 7,
        title: "ADS Cupid's Classic",
        status: "upcoming",
        description: "Registration Deadline is Jan 30",
        startDate: "2027-02-13",
        endDate: "2027-02-13",
        date: "Feb 13",
        ageGroup: "10U - 12U",
        price: "$230",
        location:
            "ADS Sports Complex, 10251 E Loop 1604 N, Converse, TX 78109",
        locationUrl:
            "https://maps.google.com/?q=10251+E+Loop+1604+N+Converse+TX+78109",

        registrationUrl: "https://www.advancedeventsystems.com/46613"
    },
    {
        id: 8,
        title: "ADS VB Developmental League #3 - Girls & Boys",
        status: "upcoming",
        description: "Registration Deadline is Jan 30",
        startDate: "2027-02-13",
        endDate: "2027-02-13",
        date: "Feb 13",
        ageGroup: "9U - 12U",
        price: "$145",
        location:
            "ADS Sports Complex, 10251 E Loop 1604 N, Converse, TX 78109",
        locationUrl:
            "https://maps.google.com/?q=10251+E+Loop+1604+N+Converse+TX+78109",

        registrationUrl: "https://www.advancedeventsystems.com/46615"
    },
    {
        id: 9,
        title: "ADS Red, White, and Rally",
        status: "upcoming",
        description: "Registration Deadline is Feb 6",
        startDate: "2027-02-20",
        endDate: "2027-02-21",
        date: "Feb 20-21",
        ageGroup: "15u - 16u",
        price: "$425",
        location:
            "ADS Sports Complex, 10251 E Loop 1604 N, Converse, TX 78109",
        locationUrl:
            "https://maps.google.com/?q=10251+E+Loop+1604+N+Converse+TX+78109",

        registrationUrl: "https://www.advancedeventsystems.com/46642"
    },
    {
        id: 10,
        title: "ADS VB Developmental League #4- Girls and Boys",
        status: "upcoming",
        description: "Registration Deadline is Feb 7",
        startDate: "2027-02-21",
        endDate: "2027-02-21",
        date: "Feb 21",
        ageGroup: "9U - 12U",
        price: "$145",
        location:
            "ADS Sports Complex, 10251 E Loop 1604 N, Converse, TX 78109",
        locationUrl:
            "https://maps.google.com/?q=10251+E+Loop+1604+N+Converse+TX+78109",

        registrationUrl: "https://www.advancedeventsystems.com/events/46616"
    },
    {
        id: 11,
        title: "Battle of the Dome #3",
        status: "upcoming",
        description: "Registration Deadline is Feb 13",
        startDate: "2027-02-27",
        endDate: "2027-02-27",
        date: "Feb 21",
        ageGroup: "10U - 12U",
        price: "$230",
        location:
            "ADS Sports Complex, 10251 E Loop 1604 N, Converse, TX 78109",
        locationUrl:
            "https://maps.google.com/?q=10251+E+Loop+1604+N+Converse+TX+78109",

        registrationUrl: "https://www.advancedeventsystems.com/events/46617"
    },
    {
        id: 12,
        title: "ADS VB Developmental League #5- Girls and Boys",
        status: "upcoming",
        description: "Registration Deadline is Feb 21",
        startDate: "2027-03-07",
        endDate: "2027-03-07",
        date: "Mar 7",
        ageGroup: "9U - 12U",
        price: "$145",
        location:
            "ADS Sports Complex, 10251 E Loop 1604 N, Converse, TX 78109",
        locationUrl:
            "https://maps.google.com/?q=10251+E+Loop+1604+N+Converse+TX+78109",

        registrationUrl: "https://www.advancedeventsystems.com/events/46618"
    },
    {
        id: 13,
        title: "ADS Lucky Charm",
        status: "upcoming",
        description: "Registration Deadline is Feb 27",
        startDate: "2027-03-13",
        endDate: "2027-03-14",
        date: "Mar 13-14",
        ageGroup: "10U - 12U",
        price: "$425",
        location:
            "ADS Sports Complex, 10251 E Loop 1604 N, Converse, TX 78109",
        locationUrl:
            "https://maps.google.com/?q=10251+E+Loop+1604+N+Converse+TX+78109",

        registrationUrl: "https://www.advancedeventsystems.com/events/46631"
    },
    {
        id: 14,
        title: "ADS March Madness",
        status: "upcoming",
        description: "Registration Deadline is Mar 6",
        startDate: "2027-03-20",
        endDate: "2027-03-20",
        date: "Mar 20",
        ageGroup: "17U - 18U",
        price: "$230",
        location:
            "ADS Sports Complex, 10251 E Loop 1604 N, Converse, TX 78109",
        locationUrl:
            "https://maps.google.com/?q=10251+E+Loop+1604+N+Converse+TX+78109",

        registrationUrl: "https://www.advancedeventsystems.com/events/46639"
    },
    {
        id: 15,
        title: "ADS VB Developmental League #6- Girls and Boys",
        status: "upcoming",
        description: "Registration Deadline is Mar 6",
        startDate: "2027-03-20",
        endDate: "2027-03-20",
        date: "Mar 20",
        ageGroup: "9U - 12U",
        price: "$145",
        location:
            "ADS Sports Complex, 10251 E Loop 1604 N, Converse, TX 78109",
        locationUrl:
            "https://maps.google.com/?q=10251+E+Loop+1604+N+Converse+TX+78109",

        registrationUrl: "https://www.advancedeventsystems.com/events/46621"
    },
    {
        id: 16,
        title: "ADS Blossom Battle",
        status: "upcoming",
        description: "Registration Deadline is Mar 27",
        startDate: "2027-04-10",
        endDate: "2027-04-10",
        date: "Apr 10",
        ageGroup: "10U - 12U",
        price: "$230",
        location:
            "ADS Sports Complex, 10251 E Loop 1604 N, Converse, TX 78109",
        locationUrl:
            "https://maps.google.com/?q=10251+E+Loop+1604+N+Converse+TX+78109",

        registrationUrl: "https://www.advancedeventsystems.com/events/46638"
    },
    {
        id: 17,
        title: "ADS VB Developmental League #7 - Girls and Boys",
        status: "upcoming",
        description: "Registration Deadline is Mar 28",
        startDate: "2027-04-11",
        endDate: "2027-04-11",
        date: "Apr 11",
        ageGroup: "9U - 12U",
        price: "$145",
        location:
            "ADS Sports Complex, 10251 E Loop 1604 N, Converse, TX 78109",
        locationUrl:
            "https://maps.google.com/?q=10251+E+Loop+1604+N+Converse+TX+78109",

        registrationUrl: "https://www.advancedeventsystems.com/events/46623"
    },
    {
        id: 18,
        title: "ADS Battle of the Dome #4",
        status: "upcoming",
        description: "Registration Deadline is Apr 10",
        startDate: "2027-04-24",
        endDate: "2027-04-25",
        date: "Apr 24-25",
        ageGroup: "17U - 18U",
        price: "$425",
        location:
            "ADS Sports Complex, 10251 E Loop 1604 N, Converse, TX 78109",
        locationUrl:
            "https://maps.google.com/?q=10251+E+Loop+1604+N+Converse+TX+78109",

        registrationUrl: "https://www.advancedeventsystems.com/events/46641"
    },
    {
        id: 19,
        title: "ADS VB Developmental League #8 - Girls & Boys",
        status: "upcoming",
        description: "Registration Deadline is Apr 11",
        startDate: "2027-04-24",
        endDate: "2027-04-24",
        date: "Apr 24",
        ageGroup: "9U - 12U",
        price: "$145",
        location:
            "ADS Sports Complex, 10251 E Loop 1604 N, Converse, TX 78109",
        locationUrl:
            "https://maps.google.com/?q=10251+E+Loop+1604+N+Converse+TX+78109",

        registrationUrl: "https://www.advancedeventsystems.com/events/46624"
    },
    {
        id: 20,
        title: "ADS Mother's Day Volley Fest",
        status: "upcoming",
        description: "Registration Deadline is Apr 24",
        startDate: "2027-05-08",
        endDate: "2027-05-08",
        date: "May 8",
        ageGroup: "17U - 18U",
        price: "$230",
        location:
            "ADS Sports Complex, 10251 E Loop 1604 N, Converse, TX 78109",
        locationUrl:
            "https://maps.google.com/?q=10251+E+Loop+1604+N+Converse+TX+78109",

        registrationUrl: "https://www.advancedeventsystems.com/events/46640"
    },
    {
        id: 21,
        title: "ADS VB Developmental League #9 - Girls & Boys",
        status: "upcoming",
        description: "Registration Deadline is Apr 24",
        startDate: "2027-05-08",
        endDate: "2027-05-08",
        date: "May 8",
        ageGroup: "9U - 12U",
        price: "$145",
        location:
            "ADS Sports Complex, 10251 E Loop 1604 N, Converse, TX 78109",
        locationUrl:
            "https://maps.google.com/?q=10251+E+Loop+1604+N+Converse+TX+78109",

        registrationUrl: "https://www.advancedeventsystems.com/events/46626"
    },
    {
        id: 22,
        title: "ADS The Last Battle",
        status: "upcoming",
        description: "Registration Deadline is May 8",
        startDate: "2027-05-22",
        endDate: "2027-05-22",
        date: "May 22",
        ageGroup: "15U - 16U",
        price: "$230",
        location:
            "ADS Sports Complex, 10251 E Loop 1604 N, Converse, TX 78109",
        locationUrl:
            "https://maps.google.com/?q=10251+E+Loop+1604+N+Converse+TX+78109",

        registrationUrl: "https://www.advancedeventsystems.com/events/46619"
    },
    {
        id: 23,
        title: "ADS VB Developmental League #10 - Girls & Boys",
        status: "upcoming",
        description: "Registration Deadline is May 8",
        startDate: "2027-05-22",
        endDate: "2027-05-22",
        date: "May 22",
        ageGroup: "9U - 12U",
        price: "$145",
        location:
            "ADS Sports Complex, 10251 E Loop 1604 N, Converse, TX 78109",
        locationUrl:
            "https://maps.google.com/?q=10251+E+Loop+1604+N+Converse+TX+78109",

        registrationUrl: "https://www.advancedeventsystems.com/events/46629"
    },

];

export default VBTournamentsPrograms;